import {
  processCandidateDeleteRequest,
  flagCandidateDeleteRequestToProcessed,
  getCandidateDeleteRequest,
  getCompanyGDPRSettingsByLoggedineRecruiter,
} from 'wisestep-api';

export const initializeCandidateSearchObject = (size: number, candidateMappingEmail: string) => {
  return {
    candidateEmail: candidateMappingEmail ? candidateMappingEmail : '',
    linkedEmails: null,
    candidateSearchType: 'All',
    excludeDuplicateRecords: false,
    page: 0,
    size: size,
  };
};

export const dataDeleteCandidate = async (candidateEmail: string) => {
  try {
    const candidateDTO = await getCandidateDataDeleteDTOByEmail(candidateEmail);
    await processCandidateDeleteRequest(candidateEmail);
    return await flagCandidateDeleteRequestToProcessed(candidateDTO.data.id);
  } catch (error) {
    console.log(error);
  }
};

export const getCandidateDataDeleteDTOByEmail = async (candidateEmail: string) => {
  let settingsResponse;
  try {
    settingsResponse = await getCompanyGDPRSettingsByLoggedineRecruiter();
  } catch (error) {
    console.log(error);
  }
  return await getCandidateDeleteRequest(candidateEmail ?? '', settingsResponse.data.id ?? '');
};
